module.exports = __webpack_public_path__ + "static/media/package_def.203237cb.jpg";